/*
 * views/spaView.js
 * Spa View
 */

define( 'app/views/diningView',[
    'lib/event',
    'app/views/commonViewHelper',
    'hbs!app/views/templates/navbar',
    'hbs!app/views/templates/breadcrumbs',
    'hbs!app/views/templates/content',
    'hbs!app/views/templates/diningReservation',
    'hbs!app/views/templates/diningConfirmation',
    'bootstrap'
], function( Event, commonViewHelper, navbarTpl, breadcrumbsTpl, contentTpl, diningReservation, diningConfirmation){
    var diningView = {
        app : app,
        event : $.extend({},Event),
        module : "dining",
        render: function(template,data,breadcrumbs) {

        }
    };
    var setBreadCrumb = function( crumbText, crumbLink ) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.dining = app.data.breadCrumbs.dining || [];
        var spliceCrumbsAt = -1,
            existingCrumb = $.grep(app.data.breadCrumbs.dining,function(crumb,index){
                if (crumb.url==crumbLink) {
                    spliceCrumbsAt = index;
                    return true;
                }
                return false;
            }),
            currentCrumb = {name:crumbText,url:crumbLink};

        app.data.breadCrumbs.dining = existingCrumb.length ?
            $.merge(app.data.breadCrumbs.dining.slice(0,spliceCrumbsAt),[currentCrumb]) :
            $.merge(app.data.breadCrumbs.dining,[currentCrumb]);

        for(var i=0;i<app.data.breadCrumbs.dining.length;i++) {
            app.data.breadCrumbs.dining[i].last = i==(app.data.breadCrumbs.dining.length-1);
        }
    };

    diningView.event.listen('requestDiningReservationSelection', diningView, function(e, diningVenues, selectedDiningVenue, selectedDate,selectedTime,selectedCovers,selectedPromo,bookingReference){
        console.log('reading service types');
        var service = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
            return a.id==app.views.diningView.module
        }));
        app.data.breadCrumbs.dining = [{name:app.localization.dining.title,url:"#/diningBooking",last:true}];
        if (app.customization.hideOtherPropertyIfItemsInCart) {
            useDiningVenues = _.filter(diningVenues,function(x){return app.data.propertyIdsInCart.indexOf(x.PropertyId)})
        } else {
            useDiningVenues = diningVenues;
        }
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.dining.bannerMessage,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        console.log(diningVenues, service)
        $('#content').addClass('diningReservation').html( diningReservation( {
            Localization : app.localization,
            diningVenues : useDiningVenues,
            showitem:selectedDiningVenue,
            selectedDate : selectedDate,
            selectedTime : selectedTime,
            selectedCovers : selectedCovers,
            selectedPromo : selectedPromo,
            bookingReference : bookingReference
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.dining
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        // commonViewHelper.showMessages(); function moved into commonViewHelper.prepDiningForm since dispatches inside of prepDiningForm function was clearing out the messages when function was called here 
        commonViewHelper.prepDiningForm(diningVenues,selectedDiningVenue,selectedDate,selectedTime,selectedCovers,selectedPromo,bookingReference);
    });

    return window.app.views.diningView = diningView;
});

